export const sbFormatter = (
    agResponse,
    currentMetricAccessor,
    visualization,
    completeEngagementRateValues,
) => {
    if (agResponse.accountGroupsData) {
        const reducedAccountGroup = (agResponse.accountGroupsData || [])
            .map(ag => ({
                ...ag,
                partitions: [],
            }))
            .reduce((acc, ag) => {
                let partitionId = null;

                if (visualization.includes('platform')) {
                    partitionId = ag.platformId;
                } else if (visualization.includes('mediaType')) {
                    partitionId = ag.mediaTypeId;
                }

                const repeatedAgs = acc.find(
                    foundAg => foundAg.accountGroupId === ag.accountGroupId,
                );

                // Helper function to handle null values
                const aggregateValue = (currentValue, newValue) => {
                    if (currentValue === null && newValue === null) {
                        return null;
                    }
                    if (currentValue === null) {
                        return newValue;
                    }
                    if (newValue === null) {
                        return currentValue;
                    }
                    return currentValue + newValue;
                };

                if (repeatedAgs) {
                    repeatedAgs.engagementsCurrentPeriod = aggregateValue(
                        repeatedAgs.engagementsCurrentPeriod,
                        ag.engagementsCurrentPeriod,
                    );
                    repeatedAgs.engagementsPreviousPeriod = aggregateValue(
                        repeatedAgs.engagementsPreviousPeriod,
                        ag.engagementsPreviousPeriod,
                    );
                    repeatedAgs.followersCountOnCurrentPeriodEndDate =
                        aggregateValue(
                            repeatedAgs.followersCountOnCurrentPeriodEndDate,
                            ag.followersCountOnCurrentPeriodEndDate,
                        );
                    repeatedAgs.followersCountOnPreviousPeriodEndDate =
                        aggregateValue(
                            repeatedAgs.followersCountOnPreviousPeriodEndDate,
                            ag.followersCountOnPreviousPeriodEndDate,
                        );
                    repeatedAgs.postCountCurrentPeriod = aggregateValue(
                        repeatedAgs.postCountCurrentPeriod,
                        ag.postCountCurrentPeriod,
                    );
                    repeatedAgs.postCountPreviousPeriod = aggregateValue(
                        repeatedAgs.postCountPreviousPeriod,
                        ag.postCountPreviousPeriod,
                    );
                    repeatedAgs.engagementRate += ag.engagementRate;
                    repeatedAgs.platformIds = [
                        ...new Set([
                            ...repeatedAgs.platformIds,
                            ...ag.platformIds,
                        ]),
                    ];
                    repeatedAgs.accounts.push(...ag.accounts);
                    const concatAgs = repeatedAgs.accounts.concat(ag.accounts);
                    repeatedAgs.accounts = concatAgs.filter(
                        (item, idx) =>
                            concatAgs.findIndex(
                                acc => acc.platformId === item.platformId,
                            ) === idx,
                    );
                    repeatedAgs.partitions.push({
                        partitionId,
                        value: ag[currentMetricAccessor],
                    });
                } else {
                    ag.partitions.push({
                        partitionId,
                        value: ag[currentMetricAccessor],
                    });
                    acc.push(ag);
                }
                return acc;
            }, []);

        const accountGroupsWithEngagamentRate = reducedAccountGroup.map(ag => ({
            ...ag,
            engagementRate: completeEngagementRateValues.find(
                completeAg => completeAg.accountGroupId === ag.accountGroupId,
            ).engagementRate,
        }));

        return {
            ...agResponse,
            accountGroupsData: accountGroupsWithEngagamentRate,
        };
    }
    return [];
};
